import { createRouter, createWebHistory } from 'vue-router'
import loginPage from '@/components/loginPage'

// 定义所有路由
const routes = [
  {
    path: '/',
    name: 'loginPage',
    component: loginPage
  },
  {
    path: '/wellincenter',
    name: 'wellinCenter',
    component: () => import('@/components/wellinCenter.vue')
  },
  {
    path: '/workseek',
    name: 'workSeek',
    component: () => import('@/components/workSeek.vue')
  },
  {
    path: '/reportcenter',
    name: 'reportCenter',
    component: () => import('@/components/reportCenter.vue')
  },
  {
    path: '/analyticwork',
    name: 'analyticWork',
    component: () => import('@/components/analyticWork.vue'),
    children: []
  },
  {
    path: '/clothinglibrarys',
    name: 'clothingLibrarys',
    component: () => import('@/components/clothingLibrarys.vue')
  },
  {
    path: '/librarysample',
    name: 'librarySample',
    component: () => import('@/components/librarySample.vue')
  },
  {
    path: '/libraryfabric',
    name: 'libraryFabric',
    component: () => import('@/components/libraryFabric.vue')
  },
  {
    path: '/librarypattern',
    name: 'libraryPattern',
    component: () => import('@/components/libraryPattern.vue')
  },
  {
    path: '/readycart',
    name: 'readyCart',
    component: () => import('@/components/readyCart.vue')
  },
  {
    path: '/productdetail',
    name: 'productDetail',
    component: () => import('@/components/productDetail.vue')
  },
  {
    path: '/patterndetail',
    name: 'patternDetail',
    component: () => import('@/components/patternDetail.vue')
  },
  {
    path: '/fabricdetail',
    name: 'fabricDetail',
    component: () => import('@/components/fabricDetail.vue')
  },
  {
    path: '/pgarevalscan',
    name: 'pGarEvalScan',
    component: () => import('@/components/pGarEvalScan.vue')
  },

  {
    path: '/wsalepurchase',
    name: 'wSalePurchase',
    component: () => import('@/components/wSalePurchase.vue')
  },
  {
    path: '/wsampledoc',
    name: 'wSampleDoc',
    component: () => import('@/components/wSampleDoc.vue') 
  },
  {
    path: '/wpatternamount',
    name: 'wPatternAmount',
    component: () => import('@/components/wPatternAmount.vue') 
  },
  {
    path: '/wsampleamount',
    name: 'wSampleAmount',
    component: () => import('@/components/wSampleAmount.vue') 
  },
  {
    path: '/wpatternprdt',
    name: 'wPatternPrdt',
    component: () => import('@/components/wPatternPrdt.vue') 
  },
  {
    path: '/wsampleprdt',
    name: 'wSamplePrdt',
    component: () => import('@/components/wSamplePrdt.vue') 
  },
  {
    path: '/pclothinoutscan',
    name: 'pClothInOutScan',
    component: () => import('@/components/pClothInOutScan.vue')
  },
  {
    path: '/wechatauthcall',
    name: 'wechatAuthCall',
    component: () => import('@/components/wechatAuthCall.vue'),
    meta: {
      title: '授权回调',
      noAuth: true  // 不需要登录验证
    }
  },
  // 添加其他需要的路由...
  {
    path: '/:pathMatch(.*)*', // 404 路由捕获
    name: 'NotFound',
    component: () => import('@/components/notFound.vue')
  }
]

const whiteList = ['/', '/wechatauthcall']

const router = createRouter({
  history: createWebHistory(),
  routes // 使用完整的 routes 数组
})

const originalPush = router.push
router.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

router.onError((error) => {
  console.error('路由错误:', error)
})

export function resetRouter() {
  const newRouter = createRouter({
    history: createWebHistory(),
    routes
  })
  router.matcher = newRouter.matcher
}

router.beforeEach((to, from, next) => {
  // 白名单路径，不需要token
  if (whiteList.includes(to.path)) {
    return next()
  }

  // 检查token
  let token = localStorage.getItem('token') || ''
  const isValidToken = token && token !== 'null' && token !== 'undefined' && token.trim() !== ''

  if (!isValidToken) {
    const accessSource = localStorage.getItem('accessSource') || 'browser'
    if (accessSource === 'wxwork' || accessSource === 'wechat') {
      localStorage.setItem('auth_redirect', to.fullPath)
    }
    next({
      path: '/',
      query: { redirect: to.fullPath } // 保存原始目标
    })
  } else {
    // 如果路由不存在，跳转到404或首页
    if (!router.hasRoute(to.name)) {
      next('/')
    } else {
      next()
    }
  }
})

export default router